"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import EmptyStateBlocks from "./EmptyStateBlocks";
import { Heading } from "../Heading";
import { Text } from "../Text";
const BASE_CLASS_NAME = "empty-state";
const EmptyState = (_a) => {
  var _b = _a, { title, subtitle, isDashed, image, children } = _b, rest = __objRest(_b, ["title", "subtitle", "isDashed", "image", "children"]);
  return /* @__PURE__ */ React.createElement("div", __spreadValues({ className: classNames(BASE_CLASS_NAME, { [`${BASE_CLASS_NAME}--dashed`]: isDashed }) }, rest), /* @__PURE__ */ React.createElement("div", { className: `${BASE_CLASS_NAME}__content` }, image ? image : /* @__PURE__ */ React.createElement(EmptyStateBlocks, { className: `${BASE_CLASS_NAME}__image` }), /* @__PURE__ */ React.createElement(Heading, { strong: true, level: "4", align: "center", className: `${BASE_CLASS_NAME}__title` }, title), /* @__PURE__ */ React.createElement(Text, { align: "center" }, subtitle)), children);
};
export default EmptyState;
